// @flow

import * as React from "react";

function PdfLoadingSpinner(): React.Node {
    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 0"}}>
            <div style={{
                width: "36px", height: "36px", borderRadius: "50%",
                border: "3px solid #dce7d6", borderTopColor: "#224514",
                animation: "app-spin 0.8s linear infinite", marginBottom: "12px"
            }}></div>
            <div style={{color: "#8892a0", fontSize: "0.85rem"}}>Loading PDF…</div>
        </div>
    );
}

export default PdfLoadingSpinner;
